exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".no-menu[data-v-614e39b0]{height:100vh;padding-top:0}.mid-menu[data-v-614e39b0]{height:100vh;padding-top:70px}.full-menu[data-v-614e39b0]{padding-top:70px}.username[data-v-614e39b0]{position:absolute;right:20px;bottom:5px}.catalog[data-v-614e39b0]{position:absolute;right:200px;width:120px;height:38px;color:#fff;border:0;background-color:#d72429}.catalogoption[data-v-614e39b0]{font-size:.8em;font-weight:400}.body[data-v-614e39b0]{overflow:auto;height:100vh!important;background:#f8f8f8!important}.close[data-v-614e39b0]{z-index:10;padding-top:60px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-614e39b0","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./scss/cattelan/_wp_variables.scss","./node_modules/bootstrap/scss/_mixins.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/custom/cattelan/start.vue
// module id = 2180
// module chunks = 165 168